export default {
  checkIsNotNull(param){
    if(param != null && param != '' && param != undefined && param.trim() != ""){
      return true;
    }
    return false;
  },
}